import React from "react";

import { LIST_SECTION_TITLE } from "@FillInTableContainer/shared/components/TableCreatorListBox/constants/tableCreatorListBox.constants";
import { TargetListType } from "@FillInTableContainer/shared/hooks/useHandleTargetListIndex";

import * as S from "./TableCreatorAiDropdown.style";
import { AIDropdownListFormat } from "../../types/tableCreatorDropdown.types";

interface Props {
  targetItemRef: React.RefObject<HTMLLIElement>;
  aiListSet: AIDropdownListFormat[];
  targetListIndex: TargetListType;
  checkIndexOfValueInDefaultAiList: () => number;
  handleClickAIItem: (item: string) => void;
  isMultiSelect?: boolean;
  multiSelectCurrentValues?: string[];
  handleClickMultiSelectItem?: (item: string, currentValues: string[]) => void;
}

const TableCreatorAiDropdown = ({
  targetItemRef,
  aiListSet,
  targetListIndex,
  checkIndexOfValueInDefaultAiList,
  handleClickAIItem,
  isMultiSelect = false,
  multiSelectCurrentValues = [],
  handleClickMultiSelectItem,
}: Props) => {
  const isAiTarget = targetListIndex.key === "AI";

  return (
    <S.ListWrapper>
      <S.ListSectionTitle>{LIST_SECTION_TITLE.ai}</S.ListSectionTitle>
      {aiListSet.map(({ list }) =>
        list.map((aiItem, itemIndex) => (
          <S.AiItem
            key={aiItem}
            data-dropdown="list-box"
            onMouseDown={() =>
              isMultiSelect
                ? handleClickMultiSelectItem?.(aiItem, multiSelectCurrentValues)
                : handleClickAIItem(aiItem)
            }
            $isTarget={isAiTarget && itemIndex === targetListIndex.listIndex}
            ref={
              isAiTarget && itemIndex === targetListIndex.listIndex
                ? targetItemRef
                : null
            }
            $isDefaultAiValue={
              !isMultiSelect && itemIndex === checkIndexOfValueInDefaultAiList()
            }
            $isSelected={
              isMultiSelect && multiSelectCurrentValues.includes(aiItem)
            }
          >
            {aiItem}
          </S.AiItem>
        )),
      )}
    </S.ListWrapper>
  );
};

export default TableCreatorAiDropdown;
